import http, {
  videoAiInstance,
  questionAnswerAiInstance,
  videoGenerationInstance
} from './http'

function changeMachineState(state) {
  return videoAiInstance({
    method: 'GET',
    url: `/default/video-generation-comfy?machine_state=${state}`
  })
}

function generateVideo(data) {
  return videoAiInstance({
    method: 'POST',
    url: '/default/video-generation-comfy',
    data
  })
}

function generateShots(data) {
  return questionAnswerAiInstance({
    method: 'POST',
    url: '?service=shots-generation',
    data
  })
}

function mapCharacterToShots(data) {
  return questionAnswerAiInstance({
    method: 'POST',
    url: '?service=character-mapping',
    data
  })
}

function groupShotsToScenes(data) {
  return videoGenerationInstance({
    method: 'POST',
    url: '/cluster-scenes',
    data
  })
}

function concatenateVideos(data) {
  return videoGenerationInstance({
    method: 'POST',
    url: '/video-transitions',
    data
  })
}

function generateVideoStory(data) {
  return questionAnswerAiInstance({
    method: 'POST',
    url: '?service=video-story-generation',
    data
  })
}

function getAvailableCharacters() {
  return videoGenerationInstance({
    method: 'POST',
    url: '/list-exsisting-characters',
    data: {}
  })
}

function createCharacter(data) {
  return videoGenerationInstance({
    method: 'POST',
    url: '/generate-character',
    data
  })
}

function generateImageRunway(data) {
  return videoGenerationInstance({
    method: 'POST',
    url: '/runway-image-generate',
    data
  })
}

function generateTransition(data) {
  return videoGenerationInstance({
    method: 'POST',
    url: '/video-transitions',
    data
  })
}

function generateVideoRunway(data) {
  return videoGenerationInstance({
    method: 'POST',
    url: '/runway-generate',
    data
  })
}

function getTaskStatus(id) {
  return videoGenerationInstance({
    method: 'GET',
    url: `/status/${id}`
  })
}

// Get AI Videos with pagination
function getAiVideos(offset = 0, limit = 5) {
  return http({
    method: 'GET',
    url: `/ai-videos?offset=${offset}&limit=${limit}`
  });
}

// Get AI Video by ID
function getAiVideoById(id) {
  console.log(`Get AI Video by ID: ${id}`)
  return http({
    method: 'GET',
    url: `/ai-videos/${id}`
  });
}

// Create AI Video
function createAiVideo(data) {
  return http({
    method: 'POST',
    url: '/ai-videos',
    data
  });
}

// Update AI Video
function updateAiVideo(id, data) {
  return http({
    method: 'PUT',
    url: `/ai-videos/${id}`,
    data
  });
}

// Delete AI Video
function deleteAiVideo(id) {
  return http({
    method: 'DELETE',
    url: `/ai-videos/${id}`
  });
}

export {
  changeMachineState,
  generateVideo,
  generateShots,
  mapCharacterToShots,
  groupShotsToScenes,
  generateVideoStory,
  concatenateVideos,
  getAvailableCharacters,
  createCharacter,
  generateImageRunway,
  generateVideoRunway,
  generateTransition,
  getAiVideos,
  getAiVideoById,
  createAiVideo,
  updateAiVideo,
  deleteAiVideo,
  getTaskStatus
}
